// extracted by mini-css-extract-plugin
module.exports = {"text":"heroSkins-smallOnConfined-text-1584e84f"};